/** Shared SEO field definitions for Common admin translation sections. */
export function createSeoTranslationKeys(seoPrefix) {
  return [
    {
      key: `${seoPrefix}.title`,
      label: "Browser tab / meta title",
      maxLength: 70,
      hint: "Recommended max 70 characters",
    },
    {
      key: `${seoPrefix}.description`,
      label: "Meta description",
      maxLength: 160,
      multiline: true,
      hint: "Recommended max 160 characters",
    },
    {
      key: `${seoPrefix}.keywords`,
      label: "Meta keywords",
      multiline: true,
      hint: "Comma-separated",
    },
    { key: `${seoPrefix}.og.title`, label: "Open Graph title", maxLength: 200 },
    {
      key: `${seoPrefix}.og.description`,
      label: "Open Graph description",
      multiline: true,
    },
    {
      key: `${seoPrefix}.og.imageAlt`,
      label: "OG image alt text (optional)",
      maxLength: 200,
    },
    { key: `${seoPrefix}.twitter.title`, label: "Twitter card title", maxLength: 200 },
    {
      key: `${seoPrefix}.twitter.description`,
      label: "Twitter card description",
      multiline: true,
    },
  ];
}

export function createSeoTranslationSection(id, title, description, seoPrefix) {
  return {
    id,
    title,
    description,
    keys: createSeoTranslationKeys(seoPrefix),
  };
}

/** On-screen 404 page copy (paired with seo.notFound.* in one admin section). */
export const NOT_FOUND_PAGE_KEYS = [
  { key: "notFound.eyebrow", label: "Eyebrow label", maxLength: 80 },
  { key: "notFound.title", label: "Heading", maxLength: 200 },
  {
    key: "notFound.description",
    label: "Description",
    maxLength: 500,
    multiline: true,
  },
  { key: "notFound.cta.home", label: "Back to home button", maxLength: 80 },
  { key: "notFound.cta.contact", label: "Contact support link", maxLength: 80 },
];
